export default __webpack_public_path__ + "static/media/4.bf4355c2.jpg";